import React from 'react';
import {Button, SvgIcon} from "@mui/material";
import Results from './Results';
import localStrings from "../../../localStrings";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {RouterLink} from "../../../components/router-link";
import {
  charCategoryAddRoute,
  chartImplementationAddRoute,
  dashboardBaseRoute,
  establishmentAddRoute
} from "../../../routes/dashboard";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";

const ChartImplementationDetailsListView = () => {

  function getMainButtons() {
    return (
      <RouterLink to={'/' + dashboardBaseRoute + '/' + charCategoryAddRoute}
                  style={{ textDecoration: 'none' }}
      >
        <Button
          color="primary"
          variant="contained"
          startIcon={(
            <SvgIcon>
              <PlusIcon />
            </SvgIcon>
          )}
        >
          {localStrings.addChartCategory}
        </Button>
      </RouterLink>
    )
  }

  return (
    <PageWithTitle title={localStrings.chartCategoryList} mainButtons={getMainButtons()}>
       <Results/>
    </PageWithTitle>
  );
};

export default ChartImplementationDetailsListView;
